import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  userInfo: [],
  userInfoLoading: false,
};

const slice = createSlice({
  name: 'userManagementSlice',
  initialState,
  reducers: {
    userInfoSlice: (state, { payload }) => {
      state.userInfo = payload;
    },
    userInfoLoadingSlice: (state, { payload }) => {
      state.userInfoLoading = payload;
    },
  },
});

const { actions, reducer } = slice;

export const { userInfoSlice, userInfoLoadingSlice } = actions;

export default reducer;
